import {forwardRef, useEffect} from 'react';

import CardBordered from '~/common/display/CardBordered';
import Icon, {Icons, NotificationIcons} from '~/common/Icon';

import {InternalNotification} from '../types';
import s from '../styles.module.scss';

const NOTIFICATION_AUTO_HIDE_TIMEOUT = 10000;

interface NotificationItemProps extends InternalNotification {
  closeNotification: () => void;
}

const NotificationItem = forwardRef<HTMLDivElement, NotificationItemProps>(
  (
    {type, title, message, closeNotification, onClose, closeTime = NOTIFICATION_AUTO_HIDE_TIMEOUT},
    ref
  ) => {
    useEffect(() => {
      const timeout = setTimeout(() => closeNotification(), closeTime);
      return () => clearTimeout(timeout);
    }, []);

    const handleCloseNotification = () => {
      closeNotification();
      onClose?.();
    };

    return (
      <CardBordered ref={ref} className={s.notification}>
        <Icon name={NotificationIcons[type]} className={s.notification__icon} />
        <div className={s.notification__content}>
          {title && <div className={s.notification__title}>{title}</div>}
          {message && <div className={s.notification__message}>{message}</div>}
        </div>
        <div onClick={handleCloseNotification}>
          <Icon className={s['notification__icon-close']} name={Icons.crossSmall} />
        </div>
      </CardBordered>
    );
  }
);

export default NotificationItem;
